import {gql} from '@apollo/client'
import {
  getCustomEventFields,
  getCustomUserFields
} from '../../../selectors/customers'
import {getFieldDefinitions} from '../utils'
import {UseCustomerFieldsViewCustomEventConfigFragment} from './generated/use-fields'
import {useMemo} from 'react'

export const useCustomerFields = (
  environmentPreferences: unknown,
  customEvents: UseCustomerFieldsViewCustomEventConfigFragment[]
) => {
  return useMemo(() => {
    const customEventFields = getCustomEventFields(customEvents)
    const customFields = getCustomUserFields(environmentPreferences)
    const fieldDefinitions = getFieldDefinitions(
      customFields,
      customEventFields
    )

    return {
      customEventFields,
      customFields,
      fieldDefinitions
    }
  }, [environmentPreferences, customEvents])
}

useCustomerFields.fragments = {
  customEventConfig: gql`
    fragment UseCustomerFieldsViewCustomEventConfig on CustomEventConfig {
      id
      name
    }
  `
}
